module.exports = __webpack_public_path__ + "img/hr-tree-07-i-leaves.477546c5.png";